// Banner — the spec's blocked (danger) and paused (warn) bars, generalised so
// the net-new error/offline surfaces speak the same visual language.

import type { ReactNode } from 'react';

export type BannerTone = 'danger' | 'warn' | 'info';

const BG: Record<BannerTone, string> = {
  danger: 'var(--danger)',
  warn: 'var(--warn)',
  info: 'var(--surface2)',
};

export interface BannerProps {
  tone: BannerTone;
  icon?: ReactNode;
  action?: { label: string; onClick: () => void };
  /** Announce to assistive tech as it appears (errors, blocks). */
  live?: boolean;
  children: ReactNode;
}

export function Banner({ tone, icon, action, live = true, children }: BannerProps) {
  const onColour = tone !== 'info';
  return (
    <div
      role={live ? 'status' : undefined}
      aria-live={live ? 'polite' : undefined}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '11px 14px',
        borderRadius: 13,
        background: BG[tone],
        color: onColour ? '#fff' : 'var(--ink)',
        font: '600 12.5px Manrope,sans-serif',
      }}
    >
      {icon}
      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
      {action && (
        <button
          type="button"
          className="press"
          onClick={action.onClick}
          style={{
            font: '700 12.5px Manrope,sans-serif',
            color: 'inherit',
            textDecoration: 'underline',
            flex: 'none',
          }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
}
